import copy from 'copy-to-clipboard';
import { capitalize } from 'lodash-es';
import type { ReactNode } from 'react';

import { IconButton } from '@zen/DesignSystem';
import type { TableColumn } from '@zen/DesignSystem/types';

import type { BusinessUnit } from '../types';
import EditBusinessUnitButton from './EditBusinessUnitButton';

const getColumnsConfiguration = (permissions: { canEdit: boolean; showAdminSettings: boolean }): TableColumn<BusinessUnit>[] => {
  const { canEdit, showAdminSettings } = permissions;
  const tradingNameColumn: TableColumn<BusinessUnit> = {
    key: 'tradingName',
    render: (_, { tradingName }): ReactNode => {
      return <div>{tradingName}</div>;
    },
    sortable: true,
    title: 'Business unit'
  };

  const typeColumn: TableColumn<BusinessUnit> = {
    key: 'type',
    sortable: false,
    alignment: 'left',
    title: 'Type',
    render: (_, { type }): ReactNode => {
      return capitalize(type);
    }
  };

  const actionsColumns: TableColumn<BusinessUnit> = {
    key: 'actions',
    fixed: 'right',
    render: (_, { id, referencePrefix, tradingName }): ReactNode => {
      return (
        <div className="flex space-x-2">
          <IconButton icon="zicon-copy" onClick={() => copy(id)} size="medium" title="Copy business unit ID" variant="ghost" />
          {canEdit && (
            <EditBusinessUnitButton
              id={id}
              name={tradingName}
              referencePrefix={referencePrefix}
              showAdminSettings={showAdminSettings}
            />
          )}
        </div>
      );
    },
    sortable: false
  };

  const columns: TableColumn<BusinessUnit>[] = [tradingNameColumn, typeColumn, actionsColumns];

  return columns;
};

export default getColumnsConfiguration;
